import script from "./BulkAddUsersToWorkspaceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkAddUsersToWorkspaceModal.vue?vue&type=script&setup=true&lang=js"

import "./BulkAddUsersToWorkspaceModal.vue?vue&type=style&index=0&id=3392966e&lang=scss&scoped=true"
import "./BulkAddUsersToWorkspaceModal.vue?vue&type=style&index=1&id=3392966e&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3392966e"]])

export default __exports__